import { render, staticRenderFns } from "./SupplierSales.vue?vue&type=template&id=766b3e48&scoped=true&"
import script from "./SupplierSales.vue?vue&type=script&lang=js&"
export * from "./SupplierSales.vue?vue&type=script&lang=js&"
import style0 from "./SupplierSales.vue?vue&type=style&index=0&id=766b3e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766b3e48",
  null
  
)

export default component.exports